import React from 'react';
import '../assets/css/style.css';
import Swiper from 'react-id-swiper';
import imagesPath from '../config/imagesPath';
import {Helmet} from "react-helmet";

const NewsBlogs = () => {
    const params = {
        loop: true,
        slidesPerView: 4,
        spaceBetween: 15,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        autoplay: {
            delay: 10000,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 5
            },
            580: {
                slidesPerView: 1,
                spaceBetween: 15
            },
            767: {
                slidesPerView: 2,
                spaceBetween: 15
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 15
            }
        }
    }
    const newsblog = [
        {
            "date": "30",
            "months": "Nov'22",
            "img": imagesPath.img41,
            "content": "IFTA Award (Fintech Rising Star)",
            "link": "https://www.indiafintech.com/"
        }, {
            "date": "24",
            "months": "Nov'22",
            "img": imagesPath.img40,
            "content": "NBFC Award (NBFC Company of the Year(Exemplary Contribution to Financial Inclusion)",
            "link": "https://event.eletsonline.com/nbfc100/mumbai/awards"
        },
        {
            "date": "20",
            "months": "Oct'22",
            "img": imagesPath.img38,
            "content": "Revfin raises $10 million in series A funding to expand its EV financing presence to 25 states",
            "link": "https://economictimes.indiatimes.com/small-biz/sme-sector/revfin-raises-10-million-to-expand-its-ev-financing-presence-to-25-states/articleshow/94985370.cms"
        },
        {
            "date": "19",
            "months": "Oct'22",
            "img": imagesPath.img37,
            "content": "The first ESG fintech in Brazil in service to the backbone of Brazilian economic development.",
            "link": "https://www.inclusivefintech50.com/2022-cohort"
        },
        {
            "date": "21",
            "months": "Sep'22",
            "img": imagesPath.img33,
            "content": "National CSR Leadership Congress and Awards",
            "link": "https://worldcsrday.com/National-CSR-Leadership-Congress-and-Awards/index.html"
        },
        {
            "date": "26",
            "months": "Aug'22",
            "img": imagesPath.img34,
            "content": "ET Leadership Excellence Awards , North - 2022: Celebrating and recognizing top leaders",
            "link": "https://www.aninews.in/news/business/business/et-leadership-excellence-awards-north-2022-celebrating-and-recognizing-top-leaders20220826185427/"
        },
        {
            "date": "30",
            "months": "Jul'22",
            "img": imagesPath.img35,
            "content": "Leaders Of Delhi EMobility Industry Honored At EV State Leadership Awards 2022",
            "link": "https://emobilityplus.com/2022/07/30/leaders-of-delhi-emobility-industry-honored-at-ev-state-leadership-awards-2022/"
        },
        {
            "date": "21",
            "months": "Mar'22",
            "img": imagesPath.img12,
            "content": "Oye Rickshaw Partners with Revfin for Financing E-rickshaw Batteries",
            "link": "https://emobilityplus.com/2022/02/10/oye-rickshaw-partners-with-revfin-for-financing-e-rickshaw-batteries/amp/"
        },
        {
            "date": "26",
            "months": "Feb'22",
            "img": imagesPath.img13,
            "content": "The outlook of fintech in India for various business models in 2022",
            "link": "https://timesofindia.indiatimes.com/blogs/voices/the-outlook-of-fintech-in-india-for-various-business-models-in-2022/"
        },
        {
            "date": "8",
            "months": "Feb'22",
            "img": imagesPath.img8,
            "content": "No incentives' on Electric Vehicle financing was a biggest let down for us: Sameer Aggarwal Revfin",
            "link": "https://techgraph.co/budget/budget-2022-23-automobile-ev-sector-reactions/"
        },
        {
            "date": "01",
            "months": "Feb'22",
            "img": imagesPath.img15,
            "content": "Budget impact on automobile sector: EV push with battery swapping and focus on clean tech",
            "link": "https://timesofindia.indiatimes.com/business/https/timesofindia-indiatimes-com/business/india-business/budget-impact-automobile-industry-2022-live-updates-electric-vehicles/liveblog/liveblog/89264386.cms"
        },
        {
            "date": "26",
            "months": "Oct'21",
            "img": imagesPath.img14,
            "content": "Seven-day e-auto mela in Delhi to give green drive a big push",
            "link": "https://timesofindia.indiatimes.com/city/delhi/seven-day-e-auto-mela-in-delhi-to-give-green-drive-a-big-push/articleshow/87269061.cms"
        },
        {
            "date": "7",
            "months": "Jun'21",
            "img": imagesPath.img11,
            "content": "Interview with Sameer Aggarwal, Founder & CEO, Revfin",
            "link": "https://www.financialexpress.com/auto/industry/interview-with-sameer-aggarwal-founder-ceo-revfin/2266399/"
        },
        {
            "date": "27",
            "months": "Jan'21",
            "img": imagesPath.img16,
            "content": "Lending platform Revfin raises funds from Shell’s non-profit arm",
            "link": "https://www.thehindubusinessline.com/money-and-banking/lending-platform-revfin-raises-funds-from-shells-non-profit-arm/article33676679.ece"
        },
        {
            "date": "28",
            "months": "Mar'20",
            "img": imagesPath.img9,
            "content": "Never fear Shadows: My personal journey through crises.",
            "link": "https://sameeraggarwal.com/BlogDetail/never-fear-shadows/5ea90b8848f96562a508f5ef?title=Never%20fear%20Shadows&url=https://sameer-web.s3.ap-south-1.amazonaws.com/filename-1588057261701297hiy7ms.jpg "
        },
        {
            "date": "5",
            "months": "Feb'20",
            "img": imagesPath.img10,
            "content": "Revfin Pumps Up EV Demand In Tier 3 India With Psychometric Loan Analysis",
            "link": " https://inc42.com/startups/revfin-pumps-up-ev-demand-in-tier-3-india-with-psychometric-loan-analysis/"
        },
        {
            "date": "04",
            "months": "Jan'20",
            "video": imagesPath.video4,
            "content": "ई-व्हीकल पर फोकस करते #Startup फिनटेक Revfin के ग्रोथ गोल्स | Startup Nation",
            "link": imagesPath.video4
        },
        {
            "date": "09",
            "months": "Apr'24",
            "img": imagesPath.img48,
            "content": "Winners – AFI’s Inclusive Fintech Showcase 2024 - Alliance for Financial Inclusion",
            "link": "https://www.afi-global.org/newsroom/news/winners-afis-inclusive-fintech-showcase-2024/"
        },
        {
            "date": "06",
            "months": "Mar'24",
            "img": imagesPath.img49,
            "content": "Stree Shakti: International Women's Day Celebration with Customers",
            "link": "https://evstory.in/opportunities-in-electric-vehicles-financing-and-maintenance-tips-for-women-ahead-of-international-womens-day/"
        },
        {
            "date": "18",
            "months": "Mar'24",
            "img": imagesPath.img50,
            "content": "Revfin Partners with Maharashtra Government’s Social Justice Department for PM Solar2EV Initiative",
            "link": "https://emobilityplus.com/2024/03/18/revfin-partners-with-maharashtra-governments-social-justice-department-for-pm-solar2ev-initiative/"
        },
        {
            "date": "20",
            "months": "Mar'24",
            "img": imagesPath.img51,
            "content": "Revfin partners with Sun Mobility to deploy 1 lakh EVs to strengthen last mile mobility",
            "link": "https://www.linkedin.com/posts/et-auto_revfin-partners-with-sun-mobility-to-deploy-activity-7175478844252983297-8B0w/"
        },
        {
            "date": "29",
            "months": "Mar'24",
            "img": imagesPath.img52,
            "content": "Revfin at TOP 10 BEST PLACE TO WORK IN 2024",
            "link": "https://m.economictimes.com/news/india/top-10-best-place-to-work-in-2024/articleshow/108852458.cms"
        },
        {
            "date": "12",
            "months": "Jul'24",
            "img": imagesPath.img58,
            "content": "Anticipating India’s Electric Vehicles Era : Exploring the Promise of the likely New Policy",
            "link": "https://www.financialexpress.com/business/express-mobility-anticipating-indias-electric-vehicles-era-exploring-the-promise-of-the-likely-new-policy-3509520/"
        },
        {
            "date": "14",
            "months": "Apr'24",
            "img": imagesPath.img59,
            "content": "EV financing start-up Revfin to raise around ₹2,000 crore in the next year",
            "link": "https://www.thehindubusinessline.com/companies/ev-financing-start-up-revfin-to-raise-around-2000-crore-in-the-next-year/article68064364.ece"
        },
        {
            "date": "26",
            "months": "Jun'24",
            "img": imagesPath.img60,
            "content": "Revfin Unveils ‘Jagriti Yatra Abhiyaan’ To Support EV Adoption In Uttar Pradesh",
            "link": "https://www.mobilityoutlook.com/news/revfin-unveils-jagriti-yatra-abhiyaan-to-support-ev-adoption-in-uttar-pradesh/"
        },
        {
            "date": "5",
            "months": "Jun'24",
            "img": imagesPath.img61,
            "content": "Revfin partners with KPTL and Bluwheelz to launch retrofitted electric trucks in India",
            "link": "https://www.wiondrive.com/news/revfin-partners-with-kptl-and-bluwheelz-to-launch-retrofitted-electric-trucks-in-india-27052/"
        },
        {
            "date": "6",
            "months": "Aug'24",
            "img": imagesPath.img62,
            "content": "Revfin and Bajaj Auto partner to boost high-speed electric three-wheeler adoption",
            "link": "https://energy.economictimes.indiatimes.com/news/power/revfin-and-bajaj-auto-partner-to-boost-high-speed-electric-three-wheeler-adoption/112310348"
        },
        {
            "date": "6",
            "months": "Aug'24",
            "img": imagesPath.img63,
            "content": "Initiative to adopt electric vehicle EV in Indore: Revfin's 'Jagruti Yatra Abhiyan' promises to bring revolution of EV in Madhya Pradesh",
            "link": "https://www.bhaskar.com/local/mp/indore/news/initiative-to-adopt-electric-vehicle-ev-in-indore-133350778.html"
        },
    ]

    return (
        <div>
            <Helmet>
                <meta name="keywords" content="apply for a eloan in India,
                    best companies for eloans in India,
                    best lending platform in India,
                    best loan apps india,
                    best nbfc for personal loan in India,
                    digital lending apps in india,
                    digital lending companies in india,
                    digital lending platforms in india,
                    fintech lending companies in india,
                    fintech loan app in india,
                    list of digital lending companies in india,
                    electric vehicle financing in india,
                    electric vehicle finance companies in india,
                    e rickshaw finance company in delhi,
                    e rickshaw finance company in India,
                    Fastest Electric Vehicle Loans in India,
                    Financing e-rickshaws in India,
                    e-rickshaws loans in India"/>

            </Helmet>
            <section className="slider_loan">
                <div className="container" data-aos="fade-up">
                    <div className="section-titles">
                        <h3 className="heading_tow">NEWS & BLOGS</h3>
                    </div>
                    <div className="cara_slider newAdditon">
                        <Swiper {...params} >
                            {newsblog.map((ele, index) => {
                                if (ele.img) {
                                    return (
                                        <div className="swiper-slide" data-aos="fade-up" key={index}>
                                            <div className="slider_pannel"><span className="date"><span
                                                className="text-orange">{ele.date}</span> {ele.months}</span>
                                                <img src={ele.img} alt='' width="100%"
                                                     style={{
                                                         paddingTop: "10px",
                                                         width: "100%",
                                                         objectFit: "contain",
                                                         height: "118px"
                                                     }}/>
                                                <div className="blog-footersect">
                                                    <p>{ele.content}</p>
                                                    <a href={ele.link} target="_blank">
                                                        <img src={imagesPath.img4} alt='' width="90px"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div className="swiper-slide" data-aos="fade-up" key={index}>
                                            <div className="slider_pannel">
                                            <span className="date"><span
                                                className="text-orange">{ele.date}</span> {ele.months}</span>
                                                <iframe className="testimonial-width" src={ele.video}
                                                        title="YouTube video player" frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        allowFullScreen
                                                        style={{
                                                            paddingTop: "10px",
                                                            width: "100%",
                                                            objectFit: "contain",
                                                            height: "118px"
                                                        }}>
                                                </iframe>
                                                <div className="blog-footersect">
                                                    <p>{ele.content}</p>
                                                    <a href={ele.link} target="_blank">
                                                        <img src={imagesPath.img5} alt='' width="90px"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            })}
                        </Swiper>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default NewsBlogs;



// WEBPACK FOOTER //
// ./src/components/NewsBlogs.js